/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Editor_Snap_To_Shot_Changes_HelpInputs */



/**
* | output |
* | --- |
* | "Automatically snap to shot changes when updating Timeline Events." |
*
* @param {Options_Editor_Snap_To_Shot_Changes_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_editor_snap_to_shot_changes_help = /** @type {((inputs?: Options_Editor_Snap_To_Shot_Changes_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Editor_Snap_To_Shot_Changes_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aligner automatiquement sur les changements de plan lors de la mise à jour des événements de la timeline.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Automatische Anpassung an Szenenänderungen beim Aktualisieren von Zeitleistenereignissen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggancia automaticamente alle modifiche di ripresa durante l'aggiornamento degli eventi della cronologia.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Автоматическая привязка к изменениям кадров при обновлении событий на временной шкале.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ajustar automáticamente los cambios de toma al actualizar los eventos de la línea de tiempo.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("更新时间线事件时，自动捕捉镜头变化。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("タイムライン イベントを更新するときに、ショットの変更に自動的にスナップします。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टाइमलाइन इवेंट्स को अपडेट करते समय शॉट में हुए बदलावों को स्वचालित रूप से स्नैप करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ajuste automático às mudanças de cena ao atualizar os eventos da linha do tempo.")
	return /** @type {LocalizedString} */ ("Automatically snap to shot changes when updating Timeline Events.")
});